module.exports = __webpack_public_path__ + "static/media/IMG_8517.b959c592.jpeg";